import { mediaSrc } from "@/components/ProductMediaUploader";
import { useEffect, useState } from "react";
import { http, formatINR } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Package, Sparkles, Award } from "lucide-react";

const STEPS = ["placed", "processing", "dispatched", "out_for_delivery", "delivered"];

export default function CustomerAccount() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    http.get("/orders/mine").then((r) => setOrders(r.data));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <div className="text-xs font-mono text-[#D97706] uppercase tracking-wider">My Account</div>
      <h1 className="font-serif text-4xl font-bold text-[#1A201C] mt-1">Namaste, {user?.name}</h1>

      <div className="mt-6 grid sm:grid-cols-3 gap-4">
        <div className="bg-white border border-[#E2DDD5] rounded-2xl p-4">
          <Sparkles className="w-4 h-4 text-[#D97706]" />
          <div className="text-xs font-mono uppercase text-[#5A6B5D] mt-2">Loyalty Points</div>
          <div className="font-serif text-3xl font-bold text-[#1E3A2B]">{user?.loyalty_points || 0}</div>
        </div>
        <div className="bg-white border border-[#E2DDD5] rounded-2xl p-4">
          <Package className="w-4 h-4 text-[#D97706]" />
          <div className="text-xs font-mono uppercase text-[#5A6B5D] mt-2">Total Orders</div>
          <div className="font-serif text-3xl font-bold text-[#1E3A2B]">{orders.length}</div>
        </div>
        <div className="bg-white border border-[#E2DDD5] rounded-2xl p-4">
          <Award className="w-4 h-4 text-[#D97706]" />
          <div className="text-xs font-mono uppercase text-[#5A6B5D] mt-2">Verified Member</div>
          <div className="font-serif text-xl font-bold text-[#1E3A2B]">Since 2026</div>
        </div>
      </div>

      <h2 className="mt-10 font-serif text-2xl font-bold text-[#1A201C]">Order History</h2>
      <div className="mt-4 space-y-4">
        {orders.length === 0 ? (
          <p className="text-sm text-[#5A6B5D] py-8">No orders yet. Start your Ayurvedic journey.</p>
        ) : orders.map((o) => {
          const stepIdx = STEPS.indexOf(o.status);
          return (
            <div key={o.id} className="bg-white border border-[#E2DDD5] rounded-2xl p-5" data-testid={`account-order-${o.id}`}>
              <div className="flex justify-between items-start flex-wrap gap-3">
                <div>
                  <div className="text-xs font-mono text-[#5A6B5D]">ORDER #{o.id.slice(0, 8).toUpperCase()}</div>
                  <div className="text-xs text-[#5A6B5D] mt-1">AWB {o.awb} · {o.items.length} item(s)</div>
                </div>
                <div className="text-right">
                  <div className="font-bold text-[#1E3A2B]">{formatINR(o.total)}</div>
                  <div className="text-[10px] font-mono uppercase text-[#5A6B5D]">{o.payment_method}</div>
                </div>
              </div>

              <div className="mt-4 flex items-center gap-2">
                {STEPS.map((s, i) => (
                  <div key={s} className="flex-1">
                    <div className={`h-1.5 rounded-full ${i <= stepIdx ? "bg-[#1E3A2B]" : "bg-[#E2DDD5]"}`} />
                    <div className={`text-[10px] font-mono uppercase mt-1 ${i <= stepIdx ? "text-[#1E3A2B]" : "text-[#5A6B5D]"}`}>
                      {s.replace(/_/g, " ")}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 grid sm:grid-cols-2 gap-2 text-xs">
                {o.items.map((it, i) => (
                  <div key={i} className="flex items-center gap-2 bg-[#FAF8F5] rounded-lg p-2">
                    <img src={mediaSrc(it.image_url)} alt="" className="w-10 h-10 rounded object-cover" />
                    <div className="flex-1 min-w-0">
                      <div className="font-semibold truncate">{it.product_name}</div>
                      <div className="font-mono text-[#5A6B5D]">Qty {it.quantity} · {formatINR(it.line_total)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
